var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container dashboard-container"},[_c('todo-side-bar',{attrs:{"selected":"dashboard"}}),_c('h1',[_vm._v(_vm._s(_vm.$t('pages.dashboard')))]),_c('todo-stat')],1)}
var staticRenderFns = []

export { render, staticRenderFns }